import { useEffect } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { useNavigationPersistence } from '@/hooks/useNavigationPersistence';
import Login from "./Login";

const Index = () => {
  const { user, loading } = useAuth();
  const { restoreLastRoute } = useNavigationPersistence();

  useEffect(() => {
    if (!loading && user) {
      // User is authenticated, restore last route
      restoreLastRoute();
    }
  }, [user, loading, restoreLastRoute]);

  return <Login />;
};

export default Index;
